/**
 * Helper for forming Jobs Urls based on route and parameters
 */
import * as urlConstants from '../../constants/url';
import { BASE_URL, GOVERNMENT_JOBS_ROLE_ALIAS,GOVERNMENT_JOBS_ROLE } from '../../constants';
import pathToRegexp from 'path-to-regexp';
import formurlencoded from 'form-urlencoded';
import  Cookies  from 'universal-cookie';
import 'url-search-params-polyfill';
import root from 'window-or-global';


export default class UrlBuilder {
	/**
	 * Get Jobs Snb Url's from parameter
	 * @param {*} params
	 */
	getJobsSnbUrl(params) {
		// Loop through Each Key and form seo url key
		let urlFormat = this.getUrlFromIdentifires(params);

		urlFormat = BASE_URL+'/'+urlFormat;
		return urlFormat;
	}

	/**
	 * Get OrderedKey from url params
	 * @param {*} params
	 */
	getUrlFromIdentifires(params) {
		//Appending Get parameters
		let getParams = {};

		//If city is not passed get from cookie
		if (!params || !params.city){
			let cookies = new Cookies();
			let city = cookies.get('new_prefer_city');
			if (city) {
				params.city = city;
			}
		}

		if (params.city && !(params.city instanceof Array)){
			params.city = this.sanitizeCity(params.city);
		}

		// Remove search if role is selected
		if (params.role){
			delete(params.keyword);
		}
		//Keywords seo url handlibg
		if (params.keyword){
			for (let key in params){
				if (Object.prototype.hasOwnProperty.call(params, key) ) {
					if (urlConstants.KEYWORD_URL_PARAMS.indexOf(key) < 0){
						getParams[key] = (params[key] instanceof Array && params[key].length>0)?params[key][0]:params[key];
						delete(params[key]);
					}
				}
			}
		}
		// Handling for all india and www case
		if ( 'All  India' ===  params.city  || params.city === 'www' || params.city === ''){
			delete(params.city);
		}

		// Special Case for Govt Jobs
		if (params.role && params.role === GOVERNMENT_JOBS_ROLE){
			params.role = GOVERNMENT_JOBS_ROLE_ALIAS;
		}
		let urlKey = '';
		let sanitizedParams = [];

		for (let key in urlConstants.URL_PARAMS_ORDER){
			if (Object.prototype.hasOwnProperty.call(urlConstants.URL_PARAMS_ORDER, key) ) {
				let value = urlConstants.URL_PARAMS_ORDER[key];
				if (Object.prototype.hasOwnProperty.call(params, value)){
					sanitizedParams.push(this.santizeUrlParam(params[value]));
					urlKey = (urlKey === '')?value:urlKey+'-'+value;
				}
			}
		}
		let url =  '';
		if (urlConstants.URL_IDENTIFIERS.hasOwnProperty(urlKey)) {
			let identifier = urlConstants.URL_IDENTIFIERS[urlKey];

			//let pathRegex = pathToRegexp.compile(urlConstants.SNB_PATH_REGEX);
			//url = pathRegex({ query: sanitizedParams.join(urlConstants.PARAMETER_SEPERATOR),identifier });
			url += sanitizedParams.join(urlConstants.PARAMETER_SEPERATOR)+urlConstants.PARAMETER_SEPERATOR+urlConstants.SNB_URL_STRING+identifier;
		}

		for (let key in urlConstants.GET_PARAMS){
			if (Object.prototype.hasOwnProperty.call(params, urlConstants.GET_PARAMS[key]) &&  params[urlConstants.GET_PARAMS[key]].length > 0 ) {
				getParams[urlConstants.GET_PARAMS[key]] = params[urlConstants.GET_PARAMS[key]][0];
			}
		}

		if (getParams.salary && ! (getParams.salary instanceof Array) ){
			getParams.salary =  getParams.salary.replace(/[^0-9]/g,'');
			//getParams.salary  = getParams.salary.match(/\d+$/)[0];
		}
		if (Object.keys(getParams).length > 0 ){
			url = url+'?'+formurlencoded(getParams);
		}


		return url;
	}

  // Remove x: from international cities
  sanitizeCity(city) {
    try {
      return city.replace('x:', '').replace(/([A-Z])/g, ' $1').trim();
    } catch (e) {
      return '';
    }
  }

  /**
   * Sanitize Url Parameters for seo purpose
   * @param {*} param
   */
  santizeUrlParam(param) {
    //If parameter is array join them
    if (param instanceof Array) {
      param = param.join(urlConstants.ARRAY_SEPERATOR);
    }

    if (typeof param !== "undefined" && param !== null && param !== '') {
      try {
        return param.replace(urlConstants.URL_PATTERN, urlConstants.SANITIZE_URL_SEPERATOR).toLowerCase();
      } catch (e) {
        return '';
      }
    }
  }

  /**
   * Get Parameters from parameter string
   */
  getParametersFromString(paramString) {
    return paramString.split(urlConstants.ARRAY_SEPERATOR);
  }

  /**
   * Parse Url get Parameters.
   * @param {*} url (UrlString with parameters)
   * @param ssr (if this is called from node server)
   * @return params object
   */
	parseSnbUrl(url, ssr=false) {
		// get identifier from url and parse values
		let keys = [];
		let regex = pathToRegexp(urlConstants.SNB_PATH_REGEX,keys);
		let tokens = regex.exec(url);
		if (!tokens) {
			return {};
		}

		let paramString = tokens[1];
		let identifier = tokens[3];
		const resultIndex = Object.keys(urlConstants.URL_IDENTIFIERS).find(key => urlConstants.URL_IDENTIFIERS[key] === identifier);

    let searchString = '';
    if (ssr) {
    } else {
      searchString = (root.location && root.location.hash !== '')
        ? root.location.hash
        : (root.location && root.location.search !== '')
          ? root.location.search
          : '';
    }
	let urlParams = this.getUrlParams(searchString);

		// All get parameters from url
		try {

			return  Object.assign({}, urlParams,  this.getParametersFromIdentifier(paramString,resultIndex));
		} catch (error) {
			return urlParams;
		}

	}

	/**
	 * Mapping parameter values and keys
	 * @param {*} paramString
	 * @param {*} IdentifierString
	 */
	getParametersFromIdentifier(paramString,IdentifierString) {
		let paramsArray = paramString.split(urlConstants.PARAMETER_SEPERATOR);
		let identifierArray = IdentifierString.split(urlConstants.SANITIZE_URL_SEPERATOR);

		let params = {};
		paramsArray.forEach((value,index) => {
			if (identifierArray[index]) {
				params[identifierArray[index]] = this.getParametersFromString(value);
			}
		});
		if(params.companyJobs){
			params.keyword = params.companyJobs;
		}

		if (params.indexedKeyword){
			params.keyword = params.indexedKeyword;
		}
		return params;
	}

	getJobIdFromVapUrl(url) {
		let regex = pathToRegexp(urlConstants.VAP_PATH_REGEX);
		let tokens = regex.exec(url);
		if (!tokens) {
			return 0;
		}
		let jobId = tokens[2];
		return jobId;
	}

	getUrlParams (url) {
		let searchParams = new URLSearchParams(url);
		let getParams = {};
		urlConstants.GET_PARAMS.forEach((value,index) => {
			if (searchParams.has(value)){
				getParams[value] = this.getParametersFromString(searchParams.get(value));
			}
		});
		return getParams;
	}

  static getPageTypeFromUrl(url) {
    let pageType = '';

    if (!url) {
      url = root.location.href;
    }

    if (url.indexOf('W0QQAdIdZ') > -1) {
      pageType = 'VAP';
    } else if (url.indexOf('zwqxj') > -1) {
      pageType = 'SNB';
    }

    return pageType;
  };

}



// WEBPACK FOOTER //
// ../q-jobs/src/utils/Search/UrlBuilder.js